import api_ef from './ef/api';
import config from '../../globals/config'
import {ListEventsForUserOptions} from "../../Interfaces/efData";
const PLATFORM = config.REACT_APP_PLATFORM;
interface IApi {
    getEvent(event_id: string): Promise<{}>
    listEvents(user_id: string, options:ListEventsForUserOptions): Promise<{}>;
    fetchInviteesBatchForEvent(event_id: string, page: number, itemsPerPage: number, tenant_id?: string): Promise<{}>;
    fetchSitePages?(eventId: string, page?:number, itemsPerPage?:number): Promise<{}>;
    listGroups?(client_Id: string): Promise<{}>;
    listUsersInGroup?(groupId: string, poolId: string, page: number, itemsPerPage: number): Promise<{}>;
    logout(email: string): Promise<{}>;
    getUser(client_id: string): Promise<{}>;
    getUserByEmail(email: string): Promise<{}>;
    getMe(): Promise<{}>;
    fetchInviteeCountsForEvent?(eventId: string): Promise<{}>;

}

function getApi(): IApi {
    switch (PLATFORM) {
        case 'ef':
            return api_ef;
        default:
            return api_ef;
    }
}

export default getApi();
